<template>

    <form ref="instituicaoensinousuario-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-12">
                <label for="escolaId">Escola CNA</label>
                <select v-select="{ dataitem: 'Escola', default: 'Selecione' , filters: { AttributeBehavior: 'EscolaBoxParametroCNANaEscola'}}" v-model="model.escolaId" class="form-control" name="escolaId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="instituicaoEnsinoId">Instituição de Ensino</label>
                <select v-select="{ dataitem: 'InstituicaoEnsino', default: 'Selecione' }" v-model="model.instituicaoEnsinoId" class="form-control" name="instituicaoEnsinoId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="email">E-mail para acesso</label>
                <input type="text" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" class="form-control" name="email" placeholder="Endereço de E-mail" v-model="model.email" required />
            </div>
            <div class="form-group col-md-12">
                <label for="senha">Senha</label>
                <input type="password" class="form-control" name="senha" placeholder="Senha" v-model="model.senha" required />
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinousuario-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "instituicaoensinousuario-form-edit",
            
            resources: {
                edit: 'instituicaoensinousuario',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api("InstituicaoEnsinoUsuario/UpdateInstituicaoEnsinoUsuario").put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ id: this.id }).then(data => {

                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>